export const GET_INDICATORS_SUCCESS = "GET_INDICATORS_SUCCESS";
export const GET_INDICATORS_FAILURE = "GET_INDICATORS_FAILURE";
export const GET_INDICATORS_STARTED = "GET_INDICATORS_STARTED";

export const GET_SIS_SUCCESS = "GET_SIS_SUCCESS";
export const GET_SIS_FAILURE = "GET_SIS_FAILURE";
export const GET_SIS_STARTED = "GET_SIS_STARTED";
